import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { saveAs } from "file-saver";

import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import { Button, showSnackbar } from "@cofano/cck";

import { Tooltip } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";

import { CustomDialog } from "components/dialogs/Dialogs";

import { Language } from "imports/Utils";

interface RechargeDownloadButtonProps {
	cargoActionIds: number[];
	disabled: boolean;
	columnIds: string[];
}

const RechargeDownloadButton = ({ cargoActionIds, disabled, columnIds }: RechargeDownloadButtonProps) => {

	const [ dialogOpen, openDialog ] = useState(false);
	const [ loading, setLoading ] = useState(false);

	const { instance } = useCoastguard();

	const downloadRecharge = async () => {
		setLoading(true);

		instance.fetchBlob("/recharge/download", {
			method: "POST",
			body: {
				cargoActionIds,
				columnIds,
			} as BodyInit & { cargoActionIds: number[], columnIds: string[] },
			headers: {
				Accept: "application/vnd.ms-excel",
			},
		}).then(async (blob) => {
			saveAs(blob, "recharge.xlsx");
		}).catch((error) => {
			showSnackbar(error.error.message, { variant: "error" });
		}).finally(() => {
			openDialog(false);
			setLoading(false);
		});
	};

	const ButtonTooltip: React.FC<{ children: React.ReactNode }> = ({ children }) => {
		if (disabled) {
			return (
				<Tooltip title={intl.formatMessage({ id: "PLEASE_SELECT_LESS_THAN_200_RECHARGE_LINES" })}>
					<span>
						{children}
					</span>
				</Tooltip>
			);
		} else {
			return children;
		}
	};

	return (
		<React.Fragment>
			<ButtonTooltip>
				<Button
					disabled={disabled || loading}
					loading={loading}
					size="small"
					onClick={() => openDialog(true)}
					variant="outlined">
					<GetAppIcon />
				</Button>
			</ButtonTooltip>

			<CustomDialog
				open={dialogOpen}
				onClose={() => openDialog(false)}
				title={Language("EXPORT")}
				actions={
					<Button
						onClick={() => downloadRecharge()}
						loading={loading}
						size="small">
						{Language("EXPORT")}
					</Button>
				}>
				{Language("RECHARGE_EXPORT")}
			</CustomDialog>
		</React.Fragment>
	);
};

export default RechargeDownloadButton;
